import './index.scss';

(function ($) {
  const $guidesShowPage = $('.q-guides-page-show');
  const selectIcon = (e) => {
    return $(e.currentTarget).siblings().find('.q-icon');
  };

  $('.collapse', $guidesShowPage).on('show.bs.collapse', (e) => {
    const $icon = selectIcon(e);
    $icon.removeClass('q-icon-angle-down');
    $icon.addClass('q-icon-angle-up');
  });
  
  $('.collapse', $guidesShowPage).on('hidden.bs.collapse', (e) => {
    const $icon = selectIcon(e);
    $icon.removeClass('q-icon-angle-up'); 
    $icon.addClass('q-icon-angle-down');      
  });
})(jQuery);
